import React from "react";

/**
 * ── LEGACY SHELL — SCHEDULED FOR DELETION ──────────────────────────────────
 *
 * The original table placeholder and date format, kept together so utils/missing
 * only has to branch rather than carry the old values.
 *
 * The placeholder was a bare span in a light grey, not the tokenised mono glyph
 * the refresh uses, and the date carried the weekday and the full time.
 */
export const LEGACY_DASH = <span style={{ color: "#aaa" }}>{"\u30FC"}</span>;

export const LEGACY_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
  hour12: true
};
